import api from './api';

export interface CronogramaExecucaoMes {
  id: string;
  planoTrabalhoId: string;
  mes: string;
  valor: number;
  dataCriacao?: string;
  dataAtualizacao?: string;
}

const cronogramaExecucaoMesService = {
  listByPlano: async (planoId: string): Promise<CronogramaExecucaoMes[]> => {
    const res = await api.get(`/cronograma-execucao-meses/plano/${planoId}`);
    return res.data;
  },

  create: async (payload: Omit<CronogramaExecucaoMes, 'id' | 'dataCriacao' | 'dataAtualizacao'>): Promise<CronogramaExecucaoMes> => {
    const res = await api.post('/cronograma-execucao-meses', payload);
    return res.data;
  },

  update: async (id: string, payload: Partial<CronogramaExecucaoMes>): Promise<CronogramaExecucaoMes> => {
    const res = await api.put(`/cronograma-execucao-meses/${id}`, payload);
    return res.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/cronograma-execucao-meses/${id}`);
  },
};

export default cronogramaExecucaoMesService;
